import React, { useState } from 'react'
import Page from '../../../../../Components/Dashboard/Page'
import { Button, Container, Divider, Paper, Stack, Typography } from '@mui/material'
import { BusMgtImg } from '../../../../../Assets/svgs'
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import NewBusinessCMDialog from '../../../../../Components/CMBusinessMgt/NewBusinessCMDialog';
import CreateUI from '../../../../../Components/CMBusinessMgt/CreateUI';
import ProgressUI from '../../../../../Components/CMBusinessMgt/ProgressUI';


const CMBusinessMgt = () => {
    const [open, setOpen] = useState(false);
    const [isClosedDialog, setIsClosedDialog] = useState(false);
    const [resetState, setResetState] = useState(false);


    const handleOpen = () => {
        setOpen(true);
        setIsClosedDialog(true);
        setResetState(false);

    }
    const handleClose = () => {
        setOpen(false)
        setIsClosedDialog(false);
        setResetState(true);


    }
    return (
        <Page title="SAED | Manage Established Businesses">
            <Container maxWidth="xl">
                <Paper sx={{ padding: '32px 0px', boxSizing:"border-box" }}>
                    <Stack pl={3} pb={3}>
                        <Typography variant='h5' fontWeight={600}>Business Management</Typography>
                        <Typography variant='body1'>Add the business you created after your SAED training</Typography>
                    </Stack>
                    <Divider />
                    {/* <CreateUI handleOpen={handleOpen} /> */}
                    <ProgressUI/>
                </Paper>
            </Container>
            <NewBusinessCMDialog
                open={open}
                handleClose={handleClose}
                // singleBusinessData={singleBusinessData}
                // openNewBusinessDialog={openNewBusinessDialog}
                // handleClose={handleClose}
                // formType={formType}
                // handleOpenEditBusinessDialog={handleOpenEditBusinessDialog}
                isClosedDialog={isClosedDialog}
                resetState={resetState}
            />
        </Page>
    )
}

export default CMBusinessMgt